module.exports = __webpack_public_path__ + "img/tiktok_loading.4b72f1c8.gif";